import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'edit-contract-svg',
  templateUrl: './edit-contract-svg.component.html',
  styleUrls: ['./../../../svg.scss']
})
export class EditContractSvgComponent implements OnInit {
  @Input() active:boolean=false;
  @Input() tooltip:boolean=true;
  @Input() size: number= 22;
  public style={
    width: '22px',
    height: '22px',
  }
  constructor() { }

  ngOnInit(): void {
    this.style.width=this.size+'px';
    this.style.height=this.size+'px';
  }

}
